<template>
  <div class="wrapper">
    <!-- Navbar fija superior -->
    <nav class="bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700 fixed top-0 z-50 w-full">
      <div class="px-3 py-3 lg:px-5 lg:pl-3">
        <div class="flex items-center justify-between">
          <!-- Lado izquierdo: Logo -->
          <div class="flex items-center justify-start">
            <span class="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white">Sistema
              Clínico</span>
          </div>

          <!-- Lado derecho: Info paciente y botón menú -->
          <div class="flex items-center gap-4">
            <div class="flex items-center gap-2">
              <img v-if="paciente && (paciente.fotoPerfil || true)"
                :src="paciente.fotoPerfil || 'https://static.vecteezy.com/system/resources/previews/020/765/399/original/default-profile-account-unknown-icon-black-silhouette-free-vector.jpg'"
                class="w-8 h-8 rounded-full border-2 border-gray-200 object-cover" alt="Foto de Perfil" />
              <span class="font-medium text-gray-900 dark:text-white hidden sm:block">{{ paciente.nombre }}</span>
            </div>
            <button @click="toggleSidebar" type="button"
              class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
              aria-controls="drawer-navigation">
              <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" fill-rule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z">
                </path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Drawer/Sidebar -->
    <div id="drawer-navigation" :class="{ 'translate-x-0': sidebarVisible, '-translate-x-full': !sidebarVisible }"
      class="fixed top-0 left-0 z-50 h-screen p-4 overflow-y-auto transition-transform bg-white w-64 dark:bg-gray-800"
      tabindex="-1">
      <h5 class="text-base font-semibold text-gray-500 uppercase dark:text-gray-400">Menú</h5>
      <button @click="toggleSidebar"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 end-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
          viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
        <span class="sr-only">Cerrar menú</span>
      </button>

      <div class="py-4 overflow-y-auto">
        <ul class="space-y-2 font-medium">
          <li v-for="(item, index) in menuItems" :key="index">
            <router-link :to="'/paciente/' + pacienteId + item.route" @click="toggleSidebar"
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i
                :class="['w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white', item.icon]"></i>
              <span class="ms-3">{{ item.text }}</span>
            </router-link>
          </li>
          <li>
            <a @click="logout" href="#"
              class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
              <i class="fas fa-sign-out-alt w-5 h-5 text-gray-500"></i>
              <span class="ms-3">Cerrar Sesión</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Content -->
<div class="p-4 mt-16">
  <!-- CTA: Solicitar Láser (solo si aplica) -->
  <div
    v-if="puedeSolicitarLaser"
    class="mb-4 rounded-xl overflow-hidden bg-gradient-to-r from-[#dbe9d1] via-[#f0e9dc] to-[#e4dcd1] text-[#4b463d] shadow"
  >
    <div class="p-4 md:p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      <div>
        <h3 class="text-lg font-semibold text-[#3e3a34]">¿Quieres tratamientos de Depilación Láser?</h3>
        <p class="text-[#5a524a]">Solicita evaluación y te habilitamos los servicios en tu cuenta.</p>
      </div>
      <button
        @click="solicitarLaser"
        class="px-5 py-2 bg-white text-[#5a7050] font-semibold rounded-lg border border-[#c8c1b6] hover:bg-[#f5f1ea] transition"
      >
        Solicitar evaluación
      </button>
    </div>
  </div>
</div>


  <div class="p-4 border-2 border-gray-200 rounded-lg dark:border-gray-700 min-h-[calc(100vh-6rem)]">
    <router-view />
  </div>
</div>
<!-- Notificación de balance pendiente -->
<div
  v-if="tieneBalance"
  class="mb-4 bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-3 rounded-lg"
>
  <p><strong>¡Tienes un balance pendiente por pagar!</strong></p>
  <router-link
    :to="`/paciente/${pacienteId}/facturas`"
    class="text-orange-600 underline hover:text-orange-700"
  >
    Ver facturas
  </router-link>
</div>

<!-- Toast -->
<Toast :show="toastShow" :message="toastMsg" :type="toastType" />


</template>

<script>
import {
  doc,
  getDoc,
  updateDoc,
  addDoc,
  collection,
  serverTimestamp,
  query,
  where,
  getDocs,
  getFirestore 
} from "firebase/firestore";

import { db } from "../../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Toast from '@/components/ui/Toast.vue';
import eventBus from "@/utils/eventBus";

export default {
  name: 'PacienteLayout',
  components: { Toast },
  props: ['pacienteId'],
  data() {
    return {
      tieneBalance: false,
      sidebarVisible: false,
      isMobile: window.innerWidth <= 768,
      paciente: { nombre: '', fotoPerfil: '' },
      menuItems: [
        { route: '/citas', icon: 'fas fa-calendar', text: 'Mis Citas' },
        { route: '/recomendaciones', icon: 'fas fa-star', text: 'Recomendaciones' } ,
        { route: '/informacion', icon: 'fas fa-user', text: 'Información Personal' },
        
      ],
      puedeSolicitarLaser: false,
      toastShow: false,
      toastMsg: '',
      toastType: 'success'
    };
  },
  methods: {
    async verificarBalancePendiente() {
  try {
    const db = getFirestore();
    const facturasRef = collection(db, 'usuarios', this.pacienteId, 'facturasPendientes');
    const q = query(facturasRef, where('pagada', '==', false));

    const snap = await getDocs(q);

    this.tieneBalance = !snap.empty; // ✅ si hay al menos una factura impaga
  } catch (error) {
    console.error('Error al verificar balance pendiente:', error);
    this.tieneBalance = false;
  }
},
  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  },

  async cargarPaciente() {
  try {
    const ref = doc(db, "pacientes", this.pacienteId);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      this.$router.push('/login');
      return;
    }

    this.paciente = snap.data();

    const yaTieneLaser =
      this.paciente.servicio === 'depilacion_laser' &&
      this.paciente.activo === true;

    const sinPermisos =
      (!Array.isArray(this.paciente.serviciosPermitidos) ||
      this.paciente.serviciosPermitidos.length === 0) &&
      !yaTieneLaser;

    const noPendiente = this.paciente.solicitudLaserPendiente !== true;

    const q = query(
      collection(db, "solicitudesLaser"),
      where("pacienteId", "==", this.pacienteId),
      where("estado", "==", "aprobado")
    );

    const snapAprobadas = await getDocs(q);
    const yaAprobado = !snapAprobadas.empty;

    this.puedeSolicitarLaser = sinPermisos && noPendiente && !yaAprobado;
    await this.verificarBalancePendiente();
    this.toastShow = false;

  } catch (error) {
    console.error("Error al cargar los datos del paciente:", error);
  }
},


  async solicitarLaser() {
    try {
      // Crear solicitud en Firestore
      await addDoc(collection(db, 'solicitudesLaser'), {
        pacienteId: this.pacienteId,
        estado: 'pendiente',
        creado: serverTimestamp()
      });

      // Marcar flag en paciente para evitar duplicados
      await updateDoc(doc(db, 'pacientes', this.pacienteId), {
        solicitudLaserPendiente: true
      });

      // Ocultar CTA
      this.puedeSolicitarLaser = false;

      // Toast + redirección
      this.toastType = 'success';
      this.toastMsg = 'Solicitud enviada. Te avisaremos cuando esté aprobada.';
      this.toastShow = true;

      setTimeout(() => {
        this.toastShow = false;
        this.$router.push(`/paciente/${this.pacienteId}/citas`);
      }, 1400);
    } catch (e) {
      console.error(e);
      this.toastType = 'error';
      this.toastMsg = 'No pudimos enviar tu solicitud. Intenta de nuevo.';
      this.toastShow = true;

      setTimeout(() => { this.toastShow = false; }, 1800);
    }
  },

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  },

  logout() {
    localStorage.removeItem('authToken');
    this.$router.push('/login');
  }
},

mounted() {
  onAuthStateChanged(getAuth(), (user) => {
    if (user) {
      this.cargarPaciente();
      
    } else {
      this.$router.push('/login');
    }
  });

  window.addEventListener("resize", this.checkIfMobile);

  // 🔁 Escuchar si la solicitud fue aprobada
  eventBus.on("solicitudesLaserActualizadas", () => {
    console.log("↻ Recargando datos del paciente por actualización externa...");
    this.cargarPaciente(); // ← recarga los datos desde Firestore
  });
},



beforeUnmount() {
  window.removeEventListener("resize", this.checkIfMobile);
  eventBus.off("solicitudesLaserActualizadas");
}

};
</script>

<style>
/* Eliminamos las variables CSS anteriores ya que usaremos el color blanco directamente */
</style>